export default "__VITE_ASSET__347b3076__"